// firestoreUtils.js
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { firestore } from './Firebase'; // Adjust the import based on your Firebase setup

export const getPurchaseHistory = async (userId) => {
    try {
        const userRef = doc(firestore, "users", userId);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
            return userDoc.data().purchaseHistory || []; // Return purchase history or an empty array
        } else {
            console.log("No purchase history found for this user.");
            return [];
        }
    } catch (error) {
        console.error("Error fetching purchase history:", error);
        return [];
    }
};

export const clearPurchaseHistory = async (userId) => {
    const userRef = doc(firestore, 'users', userId);
    await updateDoc(userRef, {
        purchaseHistory: [] // Clear the purchase history
    });
};